import { useNavigate } from "react-router-dom";

export function AlertCard({ title, value, color, link }) {
    const navigate = useNavigate();

    return (
        <div
            onClick={() => navigate(link)}
            className={`cursor-pointer border-l-4 border-${color}
        bg-cs-surface rounded-xl p-4 hover:bg-cs-bg-alt transition`}
        >
            <p className="text-sm text-cs-muted">{title}</p>
            <p className="text-3xl font-semibold text-cs-dark">{value}</p>
            <p className="text-xs text-cs-muted mt-1">View details →</p>
        </div>
    );
}
